export default {
    nl: {
        featureDiscovery: {
            steps: {
                start: {
                    title: 'Goed nieuws!',
                    description: 'We hebben nieuws dat we met je willen delen!',
                },
                menu: {
                    description:
                        'We hebben het menu verrijkt met nieuwe onderdelen. Zo hebben managers en beheerders direct toegang tot de rapportages.',
                },
                tasks: {
                    description:
                        'En vindt iedereen zijn/haar openstaande taken, zoals beoordelingsverzoeken, in een eigen menu-onderdeel: Taken. Neem eens een kijkje!',
                },
            },
            previous: 'Vorige',
            next: 'Volgende',
            done: 'Klaar',
            pagination: 'Pagina {{currentStep}} van {{totalSteps}}',
        },
        dashboardFeatureDiscovery: {
            steps: {
                toggle: {
                    title: 'Ontdek het nieuwe dashboard!',
                    description:
                        'Schakel eenvoudig tussen het huidige en het nieuwe dashboard. Probeer het straks gerust uit!',
                },
                search: {
                    description:
                        'Vind snel wat je zoekt op het gehele platform. Ben je gekoppeld aan een Community of Leertraject? Dan staan de snelkoppelingen direct naast de zoekbalk.',
                },
                progress: {
                    description:
                        'Zie in één oogopslag jouw leervoortgang, van bekwaamheden tot e-learnings.',
                },
                continueLearning: {
                    description:
                        'Ga direct verder waar je gebleven was; hier zie je al jouw gestarte opleidingen.',
                },
                information: {
                    description:
                        'Onderaan vind je handige links die jouw organisatie voor je heeft klaargezet.',
                },
                catalog: {
                    description:
                        'Bekijk jouw persoonlijke leeraanbod in de nieuwe catalogus, of blader door het volledige aanbod zoals je gewend bent.',
                },
            },
        },
        help: 'Help',
        releaseNotes: 'Productnieuws',
        whatsNew: 'Nieuw',
        whatsNewTooltip: 'Bekijk wat er nieuw is',
        statusPage: 'Statuspagina',
        messages: 'Berichten',
        noMessages: 'Geen nieuwe berichten',
        myInformation: 'Mijn gegevens',
        message: {
            // TODO: fix this syntax
            header: `{ created, select,
                undefined {}
                other {{created} - }
            }{ sender, select,
                undefined {Systeembericht}
                other {{sender}}
            }{ autoGenerated, select,
                true { (automatisch verzonden)}
                other {}
            }`,
            to: `Aan: {{recipients}}`,
            subjectElearningNotificationMessage: 'Cursus afgerond',
            achievementMessagePassed: `''{{identityDisplayName}}'' is geslaagd voor ''{{catalogItemName}}''`,
            achievementMessageFinished: `''{{identityDisplayName}}'' heeft ''{{catalogItemName}}'' succesvol afgerond`,
            assessorAppointmentMade: `Er is een afspraak gemaakt voor ''{{studentDisplayName}}'' op ''{{dateTime}}'' om de volgende activiteit af te laten toetsen: ''{{activityDescription}}''`,
            assessorAppointmentRejected: `Het beoordelingsverzoek voor activiteit ''{{activityDescription}}'' op ''{{dateTime}}'' is afgewezen door ''{{assessorDisplayName}}''`,
            assessorAppointmentRemoved: `De afspraak van gebruiker ''{{studentDisplayName}}'' op ''{{dateTime}}'' voor activiteit ''{{activityDescription}}'' is verwijderd`,
            assessorAppointmentMadeSubject: `Toetsafspraak gemaakt`,
            assessorAppointmentRemovedSubject: `Toetsfspraak verwijderd`,
            catalogAuthRequestPermissionSubjectLearningplan:
                '{{studentDisplayName}} heeft een aanvraag voor e-learning {{displayName}} gedaan.',
            catalogAuthRequestPermissionSubjectClassroom:
                '{studentDisplayName} heeft een aanvraag voor de klassikale opleiding {{displayName}} die start op {{planningStart}} gedaan.',
            catalogAuthRequestPermissionBody: `Ga op het dashboard naar ''Autorisatie aanvragen'' om de aanvraag af te handelen.`,
            catalogAuthRequestBodyLearningPlanAccepted: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is geaccepteerd`,
            catalogAuthRequestBodyLearningPlanAcceptedRemark: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is geaccepteerd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanRejected: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is geweigerd`,
            catalogAuthRequestBodyLearningPlanRejectedRemark: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is geweigerd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanDeleted: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is verwijderd`,
            catalogAuthRequestBodyLearningPlanDeletedRemark: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is verwijderd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanUnknown: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is status onbekend`,
            catalogAuthRequestBodyLearningPlanUnknownRemark: `Je aanvraag om e-learning ''{{displayName}}'' te volgen is status onbekend. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestPermissionRevoked: `De aanvrager heeft de autorisatie voor ''{{displayName}}'' ingetrokken.`,
            catalogAuthRequestBodyClassroomAccepted: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is geaccepteerd`,
            catalogAuthRequestBodyClassroomAcceptedRemark: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is geaccepteerd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomRejected: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is geweigerd`,
            catalogAuthRequestBodyClassroomRejectedRemark: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is geweigerd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomDeleted: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is verwijderd`,
            catalogAuthRequestBodyClassroomDeletedRemark: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is verwijderd. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomUnknown: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is status onbekend`,
            catalogAuthRequestBodyClassroomUnknownRemark: `Je aanvraag om klassikale training ''{{displayName}}'' die start op {{planningStart}} te volgen is status onbekend. Je manager heeft de volgende opmerking toevoegd: {{managerRemark}}`,
            catalogAuthRequestPermissionAccepted: `Aanvraag voor ''{{displayName}}'' is geaccepteerd.`,
            catalogAuthRequestPermissionRejected: "Aanvraag voor '{{displayName}}' is geweigerd.",
            catalogAuthRequestPermissionDeleted: `Aanvraag voor ''{{displayName}}'' is verwijderd.`,
            catalogAuthRequestPermissionUnknown: `Aanvraag voor ''{{displayName}}'' is onbekend.`,
            catalogAuthRequestBodyRevokedByUser: `Gebruiker ''{{studentDisplayName}}'' heeft de autorisatieaanvraag voor ''{{displayName}}'' ingetrokken.`,
            new: 'Bericht aan gebruiker',
            newClass: 'Bericht aan cursusgroep',
            newDepartment: 'Bericht aan afdeling',
            filterByMessage: 'Filteren op bericht',
            searchSubject: 'Zoek op onderwerp',
            filterBySender: 'Filteren op afzender',
            originalMessageInfo: 'Op {{date}} heeft {{sender}} het volgende geschreven:',
            Received: 'Ontvangen',
            Sent: 'Verzonden',
            Settings: 'Instellingen',
            settings: {
                admin: {
                    title: 'Berichtenbox instellingen',
                    description:
                        'Stel hieronder de standaard berichtenbox instellingen in voor alle medewerkers. De ingestelde standaard wordt voor iedereen gehanteerd, behalve voor medewerkers die hun persoonlijke instellingen hebben aangepast in hun eigen berichtenbox.',
                },
                title: 'Mijn berichtenbox instellingen',
                emailSummary: {
                    title: 'E-mail samenvatting',
                    subtitle:
                        'Ontvang een overzicht van het aantal ongelezen berichten in de berichtenbox',
                },
                emailNotification: {
                    title: 'E-mail notificatie',
                    newMessages: 'Nieuwe berichten ook per e-mail ontvangen',
                    Expiringskill: 'Verlopende bekwaamheid',
                    skillExpiration:
                        'Notificatie bij verlopende bekwaamheid ook per e-mail ontvangen',
                },
                frequency: 'Frequentie e-mail samenvatting',
                noEmail: 'Nooit / geen samenvatting',
                none: 'Nooit / geen samenvatting',
                daily: 'Dagelijkse samenvatting',
                weekly: 'Wekelijkse samenvatting',
                monthly: 'Maandelijkse samenvatting',
            },
            skills: {
                expirationNotification: {
                    subject: `Bekwaamheden update`,
                    body: `Beste deelnemer,\n
                { expired, select,
                    0 {}
                    other {Op dit moment {expired, select, 1 {is er 1 bekwaamheid} other {zijn er {expired} bekwaamheden}} verlopen.}
                }
                { expiring, select,
                    0 {}
                    other {In de periode tot {until} {expiring, select, 1 {gaat er nog 1 bekwaamheid} other {gaan er nog {expiring} bekwaamheden}} verlopen.}
                }
                { new, select,
                    0 {}
                    other {Sinds de laatste update {new, select, 1 {is er 1 bekwaamheid} other {zijn er {new} bekwaamheden}} aan jou toegewezen.}
                }

                        Je kunt jouw bekwaamheden bekijken in je portfolio.
                    `,
                },
            },
        },
        modules: {
            accessManagement: {
                activatedRights: 'Geactiveerde rechten',
                applicationPart: 'Applicatie onderdeel',
                descriptions: `{key, select,
                    roles_and_rights {Rollen en rechten}
                    roles_and_rights_manage_roles {Beheer rollen}
                    roles_and_rights_manage_assignments {Beheer toewijzingen}
                    classroom {Classroom}
                    classroom_manage_courses {Beheer opleidingen}
                    classroom_manage_schedules {Beheer planningen}
                    classroom_manage_enrollments {Beheer inschrijvingen}
                    classroom_manage_presence {Beheer presentie}
                }`,
            },
            errors: `{error, select,
                duplicate_name {Er is al een rol met deze naam}
                no_name_provided {Er is geen rolnaam opgegeven}
                other {Er is een fout opgetreden}
            }`,
            adminMenu: {
                labels: {
                    authorizations: 'Autorisaties',
                    general: 'Algemeen',
                    settings: 'Instellingen',
                    platform: 'Platforminstellingen',
                    learningPaths: 'Leerpaden',
                    learningPathsAndSkills: 'Leerpaden & Bekwaamheden',
                    links: 'Dashboard links',
                    catalog: 'Catalogus',
                    categories: 'Catalogus categorieën',
                    skillCategories: 'Bekwaamheidscategorieën',
                    compositionmanagement: 'E-learning',
                    scormmanagement: 'Scorm',
                    elearningmanagement: 'E-learning',
                    drafts: 'Arrangementen',
                    lti: 'LTI',
                    ltiadvantage: 'LTI 1.3',
                    scorm: 'SCORM',
                    microlearnings: 'Microlearnings',
                    youtube: 'YouTube',
                    vimeo: 'Vimeo',
                    evaluations: 'Evaluaties',
                    definities: 'Dossieritems',
                    classroom: 'Klassikaal',
                    weekoverview: 'Weekoverzicht',
                    forecastplanningreport: 'Vooruitblik',
                    presence: 'Presentie',
                    virtuallist: 'Interesselijst',
                    teachers: 'Docenten',
                    assessors: 'Toetsers',
                    assessmentForms: 'Beoordelingsformulieren',
                    assessments: 'Beoordelingen',
                    examiners: 'Toetsers',
                    reviewers: 'Beoordelaars',
                    locations: 'Locaties',
                    tools: 'Hulpmiddelen',
                    notifications: 'Notificaties',
                    mailtemplate: 'E-mailsjablonen',
                    skills: 'Leerpaden & Bekwaamheden',
                    certificates: 'Certificaten',
                    accreditation: 'Accreditatie',
                    assign: 'Toewijzen',
                    usermanagement: 'Gebruikersbeheer',
                    users: 'Gebruikers',
                    admins: 'Beheerders',
                    planners: 'Planners',
                    departmentreviewers: 'Afdelingsrapporteurs',
                    skillsreportviewers: 'Bekwaamhedenrapporteurs',
                    groups: 'Groepen',
                    roles: 'Rollen',
                    examinermanagement: 'Toetserbeheer',
                    importmanagement: 'Import',
                    exportmanagement: 'Export',
                    reports: 'Rapportages',
                    report: 'Rapportage',
                    totalReport: 'Totaalrapportage',
                    skillsReport: 'Bekwaamheden rapport',
                    usageReport: 'Gebruiksrapportage',
                    forecastReport: 'Vooruitblik rapport',
                    teacherArchive: 'Docent archief',
                    rolesandrights: 'Rechten',
                    maillogoverview: 'E-mail logging',
                    overview: 'Overzicht',
                },
            },
            mainMenu: {
                labels: {
                    start: 'Start',
                    catalog: 'Catalogus',
                    departments: 'Afdelingen',
                    learningPaths: 'Leerpaden',
                    assessor: 'Beoordelaar',
                    assessors: 'Beoordelaars',
                    manager: 'Manager',
                    functions: 'Functies',
                    workLearningMethods: 'Werkvormen',
                    myMinerva: 'Portfolio',
                    search: 'Zoeken',
                    administration: 'Beheer',
                },
            },
            portfolioMenu: {
                labels: {
                    skills: 'Bekwaamheden',
                    assigned: 'Toegewezen opleidingen',
                    results: 'Resultaten & certificaten',
                    definities: 'Dossier',
                    accreditations: 'Accreditaties',
                    activities: 'Activiteiten',
                    interests: 'Interesselijst',
                    departments: 'Afdelingen',
                    profile: 'Profiel',
                    evaluations: 'Evaluaties',
                    assessors: 'Toetsmomenten',
                    planning: 'Toetsafspraken',
                    availability: 'Beschikbaarheid',
                },
            },
        },
        notifications: 'Notificaties',
        assessmentRequests: 'Beoordelingsverzoeken',
        authorizationRequests: 'Autorisatieverzoeken',
        evaluations: 'Evaluaties',
        portfolioTasks: 'Dossieritem verzoeken',
        profile: 'Profiel',
        restartFeatureDiscovery: 'Bekijk wat er nieuw is',
        fullCatalog: 'Volledige catalogus',
        myCollection: 'Mijn leeraanbod',
        signOut: 'Uitloggen',
        tasks: 'Taken',
        unprocessedPresence: 'Niet verwerkte presentie',
        presenceProcessing: 'Presentieverwerking',
        upcomingTrainingsTeacher: 'Aankomende trainingen | trainer',
        upcomingTrainingsParticipant: 'Aankomende trainingen | deelnemer',
        uservoiceIcon: 'Wensen doorgeven',
        npsDialog: {
            cancel: 'Annuleren',
            confirm: 'Wil je 1 vraag over deze applicatie beantwoorden?',
            likely: 'Absoluut!',
            no: 'Nee',
            notLikely: 'Zeker niet',
            remarks: 'Heb je tips of feedback?',
            submit: 'Verzenden',
            title: 'Zou je deze applicatie aanbevelen?',
            yes: 'Ja',
            subTitle: 'Het duurt nog geen minuut',
            later: 'Misschien later',
            thanks: 'Bedankt voor je feedback!',
            improve: 'Met jouw feedback kunnen we onze applicatie blijven verbeteren.',
            close: 'Sluiten',
        },
    },
    en: {
        featureDiscovery: {
            steps: {
                start: {
                    title: 'Good news!',
                    description: 'We have news we would like to share with you!',
                },
                menu: {
                    description:
                        'We have enriched the menu with new sections. Managers and administrators now have direct access to the reports.',
                },
                tasks: {
                    description:
                        'And everyone will find their open tasks, such as assessment requests, in a menu section of their own: Tasks. Take a look!',
                },
            },
            previous: 'Previous',
            next: 'Next',
            done: 'Done',
            pagination: 'Page {{currentStep}} of {{totalSteps}}',
        },
        dashboardFeatureDiscovery: {
            steps: {
                toggle: {
                    title: 'Explore the new dashboard!',
                    description:
                        'Toggle between the current and new dashboard whenever you like. Give it a spin later!',
                },
                search: {
                    description:
                        "Search the entire platform and find what you need fast. If you're part of a Community or Learning Path, their shortcuts appear right next to the search bar.",
                },
                progress: {
                    description:
                        'Track your learning progress at a glance, from skills to e-learning.',
                },
                continueLearning: {
                    description:
                        'Continue where you left off; this row displays all your active courses.',
                },
                information: {
                    description:
                        'Find quick links curated by your organization at the bottom of the page.',
                },
                catalog: {
                    description:
                        'Check out your personalized learning offers in the new catalog, or browse the complete catalog as usual.',
                },
            },
        },
        help: 'Help',
        releaseNotes: 'Release notes',
        whatsNew: 'New',
        whatsNewTooltip: 'See what is new',
        statusPage: 'Status page',
        messages: 'Messages',
        noMessages: 'No new messages',
        myInformation: 'My information',
        message: {
            // TODO: fix this syntax
            header: `{ created, select,
                undefined {}
                other {{created} - }
            }{ sender, select,
                undefined {System message}
                other {{sender}}
            }{ autoGenerated, select,
                true { (sent automatically)}
                other {}
            }`,
            to: `To: {{recipients}}`,
            subjectElearningNotificationMessage: 'Course completed',
            achievementMessagePassed: `''{{identityDisplayName}}'' has passed ''{{catalogItemName}}''`,
            achievementMessageFinished: `''{{identityDisplayName}}'' has successfully completed ''{{catalogItemName}}''`,
            assessorAppointmentMade: `An appointment was made for ''{{studentDisplayName}}'' on ''{{dateTime}}'' to assess the following activity: ''{{activityDescription}}''`,
            assessorAppointmentRejected: `The assessment request for activity ''{{activityDescription}}'' on ''{{dateTime}}'' is rejected by ''{{assessorDisplayName}}''`,
            assessorAppointmentRemoved: `The appointment for user ''{{studentDisplayName}}'' on ''{{dateTime}}'' for activity ''{{activityDescription}}'' has been removed`,
            assessorAppointmentMadeSubject: `Assessment appointment created`,
            assessorAppointmentRemovedSubject: 'Assessment appointment removed',
            catalogAuthRequestPermissionSubjectLearningplan:
                "{{studentDisplayName}} has requested permission for elearning module '{{displayName}}'.",
            catalogAuthRequestPermissionSubjectClassroom: `{{studentDisplayName}} has requested permission for the classical training module ''{{displayName}}'' which starts at {{planningStart}}.`,
            catalogAuthRequestPermissionBody: `Go to the dashboard and click ''Authorization requests'' to process the request.`,
            catalogAuthRequestBodyLearningPlanAccepted: `Your request for elearning ''{{displayName}}'' is accepted`,
            catalogAuthRequestBodyLearningPlanAcceptedRemark: `Your request for elearning ''{{displayName}}'' is accepted. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanRejected: `Your request for elearning ''{{displayName}}'' is rejected.`,
            catalogAuthRequestBodyLearningPlanRejectedRemark: `Your request for elearning ''{{displayName}}'' is rejected. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanDeleted: `Your request for elearning ''{{displayName}}'' is deleted.`,
            catalogAuthRequestBodyLearningPlanDeletedRemark: `Your request for elearning ''{{displayName}}'' is deleted. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyLearningPlanUnknown: `Your request for elearning ''{{displayName}}'' is status unknown.`,
            catalogAuthRequestBodyLearningPlanUnknownRemark: `Your request for elearning ''{{displayName}}'' is status unknown. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestPermissionRevoked: `The user revoked the authorization request for ''{{displayName}}''.`,
            catalogAuthRequestBodyClassroomAccepted: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is accepted.`,
            catalogAuthRequestBodyClassroomAcceptedRemark: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is accepted. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomRejected: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is rejected`,
            catalogAuthRequestBodyClassroomRejectedRemark: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is rejected. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomDeleted: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is deleted.`,
            catalogAuthRequestBodyClassroomDeletedRemark: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is deleted. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestBodyClassroomUnknown: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is status unknown.`,
            catalogAuthRequestBodyClassroomUnknownRemark: `Your request for classical training ''{{displayName}}'' which starts at {{planningStart}} is status unknown. Your manager added the following remark: {{managerRemark}}`,
            catalogAuthRequestPermissionAccepted: `Your request for ''{{displayName}}'' is accepted.`,
            catalogAuthRequestPermissionRejected: "Your request for '{{displayName}}' is rejected.",
            catalogAuthRequestPermissionDeleted: `Your request for ''{{displayName}}'' is deleted.`,
            catalogAuthRequestPermissionUnknown: `Your request for ''{{displayName}}'' is status unknown.`,
            catalogAuthRequestBodyRevokedByUser: `User ''{{studentDisplayName}}'' revoked the authorization request for ''{{displayName}}''`,
            filterByMessage: 'Filter by message',
            searchSubject: 'Search on subject',
            filterBySender: 'Filter by sender',
            originalMessageInfo: 'On {date} {sender} wrote:',
            new: 'Message to user',
            newClass: 'Message to coursegroup',
            newDepartment: 'Message to department',
            Received: 'Received',
            Sent: 'Sent',
            Settings: 'Settings',
            settings: {
                admin: {
                    title: 'Message box settings',
                    description:
                        'Set the default message box settings for all users. These settings will apply to all users, except for users who changed their personal settings in their own message box settings.',
                },
                title: 'My messagebox settings',
                emailSummary: {
                    title: 'E-mail summary',
                    subtitle:
                        'Receive an e-mail summary with the number of unread messages in the messagebox',
                },
                emailNotification: {
                    title: 'E-mail notification',
                    newMessages: 'Receive new messages by e-mail',
                    Expiringskill: 'Expiring skill',
                    skillExpiration: 'Receive notification when skills expire by email',
                },
                frequency: 'Email summary frequency',
                noEmail: 'Never / no summary',
                none: 'Never / no summary',
                daily: 'Daily summary',
                weekly: 'Weekly summary',
                monthly: 'Monthly summary',
            },
            skills: {
                expirationNotification: {
                    subject: `Skills update`,
                    body: `Dear participant,\n
            { expired, select,
                0 {}
                other {At the moment {expired, select, 1 {1 skill has} other {{expired} skills have}} expired.}
            }
            { expiring, select,
                0 {}
                other {In the period up to {until}, {expiring} more {expiring, select, 1 {skill} other {skills}} will expire.}
            }
            { new, select,
                0 {}
                other {Since the last update, {new} {new, select, 1 {skill has} other {skills have}} been assigned to you.}
            }

            You can view your skills in your portfolio.
        `,
                },
            },
        },
        modules: {
            adminMenu: {
                labels: {
                    authorizations: 'Authorizations',
                    general: 'General',
                    settings: 'Settings',
                    platform: 'Platform settings',
                    learningPaths: 'Learning paths',
                    learningPathsAndSkills: 'Learning paths & Skills',
                    links: 'Dashboard links',
                    catalog: 'Catalog',
                    categories: 'Catalog categories',
                    skillCategories: 'Skill categories',
                    compositionmanagement: 'E-learning',
                    scormmanagement: 'Scorm',
                    elearningmanagement: 'E-learning',
                    drafts: 'Compositions',
                    lti: 'LTI',
                    ltiadvantage: 'LTI 1.3',
                    scorm: 'SCORM',
                    microlearnings: 'Microlearnings',
                    youtube: 'YouTube',
                    vimeo: 'Vimeo',
                    evaluations: 'Evaluations',
                    definities: 'Portfolio items',
                    classroom: 'Classical',
                    weekoverview: 'Week overview',
                    forecastplanningreport: 'Forecast',
                    presence: 'Presence',
                    virtuallist: 'Watchlist',
                    teachers: 'Teachers',
                    assessors: 'Assessors',
                    assessmentForms: 'Assessment forms',
                    assessments: 'Assessments',
                    examiners: 'Examiners',
                    reviewers: 'Assessors',
                    locations: 'Locations',
                    tools: 'Tools',
                    notifications: 'Notifications',
                    mailtemplate: 'Mail Templates',
                    skills: 'Learning paths & Skills',
                    certificates: 'Certificates',
                    accreditation: 'Accreditation',
                    assign: 'Assign',
                    usermanagement: 'User management',
                    users: 'Users',
                    admins: 'Administrators',
                    planners: 'Planners',
                    departmentreviewers: 'Department reviewers',
                    skillsreportviewers: 'Skills report viewers',
                    groups: 'Groups',
                    roles: 'Roles',
                    examinermanagement: 'Examiner management',
                    importmanagement: 'Import',
                    exportmanagement: 'Export',
                    reports: 'Reports',
                    report: 'Report',
                    totalReport: 'Total report',
                    skillsReport: 'Skills report',
                    usageReport: 'Usage report',
                    forecastReport: 'Forecast report',
                    teacherArchive: 'Teacher archive',
                    rolesandrights: 'Rights',
                    maillogoverview: 'E-mail logging',
                    overview: 'Overview',
                },
            },
            mainMenu: {
                labels: {
                    start: 'Start',
                    catalog: 'Catalog',
                    departments: 'Departments',
                    learningPaths: 'Learning paths',
                    assessors: 'Assessors',
                    assessor: 'Assessor',
                    manager: 'Manager',
                    skills: 'Skills',
                    functions: 'Functions',
                    workLearningMethods: 'Working forms',
                    myMinerva: 'Portfolio',
                    search: 'Search',
                    administration: 'Admin',
                },
            },
            portfolioMenu: {
                labels: {
                    skills: 'Skills',
                    assigned: 'Assigned trainings',
                    results: 'Results & certificates',
                    definities: 'Portfolio',
                    accreditations: 'Accreditations',
                    activities: 'Activities',
                    interests: 'Watchlist',
                    departments: 'Departments',
                    profile: 'Profile',
                    evaluations: 'Evaluations',
                    assessors: 'Assessment moments',
                    planning: 'Assessment appointments',
                    availability: 'Availability',
                },
            },
        },
        notifications: 'Notifications',
        assessmentRequests: 'Assessment requests',
        authorizationRequests: 'Authorization requests',
        evaluations: 'Evaluations',
        portfolioTasks: 'Portfolio tasks',
        restartFeatureDiscovery: 'See what is new',
        fullCatalog: 'Full catalog',
        myCollection: 'My collection',
        profile: 'Profile',
        signOut: 'Sign out',
        tasks: 'Tasks',
        unprocessedPresence: 'Unprocessed presence',
        presenceProcessing: 'Presence processing',
        upcomingTrainingsTeacher: 'Upcoming trainings | trainer',
        upcomingTrainingsParticipant: 'Upcoming trainings | participant',
        uservoiceIcon: 'Report a wish',
        npsDialog: {
            cancel: 'Close',
            later: 'Maybe later',
            confirm: 'Would you like to answer 1 question about this application?',
            likely: 'Absolutely!',
            no: 'No',
            notLikely: 'Definitely not',
            remarks: 'Do you have any tips or feedback?',
            submit: 'Send',
            title: 'Would you recommend this application?',
            yes: 'Yes',
            subTitle: 'It only takes 1 minute',
            thanks: 'Thanks for your feedback!',
            improve: 'Your feedback helps us continue to improve our application.',
            close: 'Close',
        },
    },
};
